module.exports = __webpack_public_path__ + "media/images/admin/icons/slack-29ff4fc03383be9d87d0baa44f4259aa.svg";